import { useGqlMutation, useGqlQuery } from 'utils/gql';
import * as constants from './constants';

const AutopayScheduleService = {
  useCreate: (options) => {
    const gqlQuery = constants.CREATE_AUTOPAY_SCHEDULE;
    const result = useGqlMutation(gqlQuery, options);
    return result;
  },

  useFindAll: (where, options) => {
    const gqlQuery = constants.FIND_ALL_AUTOPAY_SCHEDULES;
    const result = useGqlQuery(gqlQuery, { where }, options);
    return result;
  },

  useUpdate: (options) => {
    const gqlQuery = constants.UPDATE_AUTOPAY_SCHEDULE;
    const result = useGqlMutation(gqlQuery, options);
    return result;
  },

  useDelete: (options) => {
    const gqlQuery = constants.DELETE_AUTOPAY_SCHEDULE;
    const result = useGqlMutation(gqlQuery, options);
    return result;
  },
};

export default AutopayScheduleService;
